<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>

<button class="btn-volver"  (click)="volver()" >              
    Volver
</button> 

<div class="projects">
    <div class="card">
        <div class="card-header header-background">
            <div class="row">
                <div class="col-sm-3"> 
                    <p class="welcome-title">Bloc de Notas</p>
                </div>
                <div class="col-sm-6">
                    <p style="text-align: left;
                    font: normal normal 600 16px/22px Montserrat;
                    letter-spacing: 0px;
                    margin-top: 19px;
                    color: #FFFFFF;
                    opacity: 1;"> utilice este espacio digital para consignar los hallazgos, aprendizajes o consultas que surjan de este proceso de formación.</p>
                </div>
                <div class="col-sm-3" style="text-align: right;"> 
                    <img src="../../../../../../../assets/icons/ico_bloc-notas@2x.png" style="width: 90px;">
                </div>
            </div>
           
        </div>

        <div class="card-body">
            <div class="row">
                 <div class="col-sm-12" style="text-align: right;">
                    <button class="btn-volver" (click)="addNote()" style="background-color: #EE366D;padding: 10px 20px;" >  
                        <i class="far fa-plus-square"></i>            
                        AÑADIR NOTA
                    </button> 
                 </div>
            </div>
            
            <div class="app">
                <app-note-pm *ngFor="let note of notes" (dismiss)="deleteNote($event)" (focusout)="saveNote($event)" id="{{note.idBlockNotas}}">{{note.contenido}}</app-note-pm>
            </div>
        </div>

    </div>
</div>

